<template>
    <div>
        <i class="fa fa-fw text-left fa-btn fa-cog pointer" :id="tableConfigurationId" tabindex="0"></i>
            <b-popover :target="tableConfigurationId" placement="bottomleft" custom-class="contact-listing-state-popover" triggers="focus">
            <form v-on:submit.prevent="exportToExcel">
                <div class="d-flex flex-column justify-content-center pt-2">
                    <a @click="saveColumns()" class="btn btn-primary btn-sm btn-block">Save</a>
                </div>
                <div v-if="isCompanyInformation" class="d-flex flex-column justify-content-center pt-2">
                    <a @click="saveColumnsForAll()" class="btn btn-primary btn-sm btn-block">Save For All</a>
                </div>
                <Container @drop="onDrop" drag-class="opacity-ghost" drop-class="opacity-ghost-drop" :get-ghost-parent="getGhostParent">
                    <Draggable v-for="column in columns" :key="column.id">
                        <div class="draggable-item">
                            <i class="fa fa-align-justify handle pr-1"></i>
                            <b-form-checkbox
                                v-model="column.checked"
                                :disabled="(column.property_name === 'followup' || column.property_name === 'bid_status')">
                            </b-form-checkbox>
                            {{column.name}}
                        </div>
                    </Draggable>
                </Container>
                <div class="d-flex flex-column justify-content-center pt-2">
                    <a @click="saveColumns()" class="btn btn-primary btn-sm btn-block">Save</a>
                </div>
                <div v-if="isCompanyInformation" class="d-flex flex-column justify-content-center pt-2">
                    <a @click="saveColumnsForAll()" class="btn btn-primary btn-sm btn-block">Save For All</a>
                </div>
            </form>
        </b-popover>
    </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
export default {
    props: ['name' , 'contact', 'state', 'filter', 'isListExport', 'list', 'isCompanyInformation'],
    data() {
        return {
            drag: false,
            columns: this.state,
            is_residential: 0,
        };
    },
    methods: {
        saveColumns() {
            if(this.isCompanyInformation){
                this.$emit('updateCompanyInformationSection');
                $(".contact-listing-state-popover").hide()
            }else{
                window.location.reload()
            }
        },
        saveColumnsForAll() {
          $(".contact-listing-state-popover").hide()
          this.$emit('updateCompanyInformationSection');
          this.saveState(true);
        },
        saveState(saveForAll = false) {
            if(this.isListExport) {
                axios.post(route('api.lists.update-state', {filterList: this.list.id}), { state: this.columns })
                    .then(response => {
                        this.$emit('contactStateUpdated', this.columns);
                    });
            }else if(this.isCompanyInformation){
                axios.post(route('api.project-company-information-state.store'), { state: this.columns, saveForAll: saveForAll })
                    .then(response => {
                    });

            }else{
                axios.post(route('api.contact.state'), { state: this.columns, is_residential: this.is_residential })
                    .then(response => {
                        this.$emit('stateUpdated', this.columns);
                    });

            }
        },
        getGhostParent() {
            return document.body;
        },
        onDrop(dropResult) {
            const { removedIndex, addedIndex, payload } = dropResult
            if (removedIndex === null && addedIndex === null) return this.columns

            const result = [...this.columns]
            let itemToAdd = payload

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0]
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd)
            }
            this.columns = result;
            this.saveState();
        },
    },
    components: { Container, Draggable },
    computed: {
        tableConfigurationId() {
            return 'table-configuration-' + this.name;
        }
    },
    watch: {
        columns: {
            handler: function (val, oldVal) {
                this.saveState();
            },
            deep: true
        }
    },
    // created() {
    // },
    mounted() {
        if(this.name === 'ResidentialContacts'){
            this.is_residential = 1;
        }
        this.saveState();
    }
}
</script>

<style lang="scss" scoped>
.bg-qualified{
    background-color: #00ff8f;
}
tr td:nth-child(2), tr th:nth-child(2) {
    padding-left: .5rem;
}
.pointer {
    cursor: pointer;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.export-btn {
    margin-top: 5px;
}

.draggable-item {
    border: 1px solid rgba(0, 0, 0, .125);
    margin: 2px 0px;
    padding: 5px;
    cursor: move;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
}

.draggable-item .custom-control{
    margin-left: 10px !important;
}

.dragging {
    background-color: yellow;
}


.opacity-ghost {
    transition: all .18s ease;
    opacity: 0.8;
    /* transform: rotateZ(5deg); */
    background-color: cornflowerblue;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}

.opacity-ghost-drop {
    opacity: 1;
    /* transform: rotateZ(0deg); */
    background-color: white;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
}
.cards-drop-preview {
    background-color: rgba(150, 150, 200, 0.1);
    border: 1px dashed #abc;
    margin: 5px 45px 5px 5px;
}
.smooth-dnd-ghost{
    z-index: 1100 !important;
}
//.custom-control-input:checked~.custom-control-label:before {
//    color: #fff;
//    border-color: red !important;
//    background-color: red !important;
//}
</style>
<style>
.contact-listing-state-popover{
    .popover-body {
        height: 300px !important;
        overflow-y: auto !important;
        padding-bottom: 10px;
    }
}
</style>
